import * as React from "react";

import { MenuContextType } from "src/core/shared/hooks/menu/useMenu";

import { SidebarOrderQuickAction } from "./SidebarOrderQuickAction";
import { SidebarListQuickAction } from "./SidebarListQuickAction";

interface SidebarContextQuickActionProps {
  context: MenuContextType;
}

export const SidebarContextQuickAction: React.ReactFCWithChildren<SidebarContextQuickActionProps> = ({ context }) => {
  if (context.type === "ORDER_PRODUCT_SELECTION") {
    return <SidebarOrderQuickAction context={context} />;
  }

  if (context.type === "LIST_PRODUCT_SELECTION") {
    return <SidebarListQuickAction context={context} />;
  }

  return null;
};
